import { render, staticRenderFns } from "./SwitchOrStay.vue?vue&type=template&id=e280b852&lang=pug"
import script from "./SwitchOrStay.vue?vue&type=script&lang=js"
export * from "./SwitchOrStay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports